import {
	updateShippingValue
} from './_updateShippingValue';

import {
	updateShippingMethods
} from './_updateShippingMethods';


import {
	formValidation
} from '../global/_formValidation';

formValidation

const billingSameAsShipping = () => {
        var $sameAsCheckbox = $('#shipping-addr-same-as-billing-addr');
        var $shippingInputs = $('.quick-checkout-shipping-address-area input, .quick-checkout-shipping-address-area select').not($sameAsCheckbox);

        $sameAsCheckbox.change( function(event) {

            updateShippingValue();

            if ($(this).prop("checked") == true) {
                setShipping();
                disabledShippingInputs();
                $('.quick-checkout-billing-address-area input').not('.quick-checkout-shipping-address-area input').on('keyup', function() {
                    switch (this.id) {
                        case 'quick-checkout-billing-first-name':
                            $('#quick-checkout-shipping-first-name').val(this.value);
                            break;
                        case 'quick-checkout-billing-middle-initial':
                            $('#quick-checkout-shipping-middle-initial').val(this.value);
                            break;
                        case 'quick-checkout-billing-last-name':
                            $('#quick-checkout-shipping-last-name').val(this.value);
                            break;
                        case 'quick-checkout-billing-address-1':
                            $('#quick-checkout-shipping-address-1').val(this.value);
                            $('#quick-checkout-shipping-address-1-copy').val(this.value);
                            updateShippingMethods(document.quickCheckoutProfileForm);
                            break;
                        case 'quick-checkout-billing-city':
                            $('#quick-checkout-shipping-city').val(this.value);
                            break;
                        case 'quick-checkout-billing-zip-code':
                            $('#quick-checkout-shipping-zip-code').val(this.value);
                            break;
                        default:
                            break;
                    }
                });

                $('#quick-checkout-billing-state').on('change', function() {
                   $('#quick-checkout-shipping-state').val(this.value);
                   updateShippingMethods(document.quickCheckoutProfileForm);
                  if ($('#next-day').prop("checked") == true) {
                       $('.next-day-info').slideDown();
                   } else {
                       $('.next-day-info').slideUp();
                   }
               });

                 if ($('#next-day').prop("checked") == true) {
                       $('.next-day-info').slideDown();
                   } else {
                       $('.next-day-info').slideUp();
                   }


              formValidation();
            };

           if ($(this).prop("checked") == false) {
                enableShippingInputs();
                $('.quick-checkout-billing-address-area input').not('.quick-checkout-shipping-address-area input').unbind('keyup');
                $('#quick-checkout-billing-state').unbind('change');


            };

        });

 };

 const setShipping = () => {

     $('#quick-checkout-shipping-first-name').val($('#quick-checkout-billing-first-name').val());
     $('#quick-checkout-shipping-middle-initial').val($('#quick-checkout-billing-middle-initial').val());
     $('#quick-checkout-shipping-last-name').val($('#quick-checkout-billing-last-name').val());
     $('#quick-checkout-shipping-address-1').val($('#quick-checkout-billing-address-1').val());
     $('#quick-checkout-shipping-address-1-copy').val($('#quick-checkout-billing-address-1').val());
     $('#quick-checkout-shipping-city').val($('#quick-checkout-billing-city').val());
     $('#quick-checkout-shipping-state').val($('#quick-checkout-billing-state').val());
     $('#quick-checkout-shipping-zip-code').val($('#quick-checkout-billing-zip-code').val());
     updateShippingMethods(document.quickCheckoutProfileForm);
 };

 const disabledShippingInputs = () => {
	 var $sameAsCheckbox = $('#shipping-addr-same-as-billing-addr');
	 var $shippingInputs = $('.quick-checkout-shipping-address-area input, .quick-checkout-shipping-address-area select').not($sameAsCheckbox);
     $shippingInputs.prop("readonly", true);
     $shippingInputs.attr("disabled", true);
     $('.quick-checkout-shipping-address-area select').attr('disabled', true);
     $('.quick-checkout-shipping-address-area .form-group').removeClass('has-error');

 };

 const enableShippingInputs = () => {
	 var $sameAsCheckbox = $('#shipping-addr-same-as-billing-addr');
	 var $shippingInputs = $('.quick-checkout-shipping-address-area input, .quick-checkout-shipping-address-area select').not($sameAsCheckbox);
     $shippingInputs.removeAttr('readonly');
     $shippingInputs.attr("disabled", false);
     $('.quick-checkout-shipping-address-area select').attr('disabled', false);
 };

export {
 	billingSameAsShipping,
 	setShipping,
    disabledShippingInputs,
    enableShippingInputs
}
